import React from 'react'
import { Col, Row, Container } from 'react-bootstrap'
import { StyledLogo, StyledTitle, StyledRow } from './styled'

const Customers = (props) => {
    return (
        <Container fluid className='px-0'>
            <StyledRow className='mx-0'>
                {
                    props.title && (
                        <Col xs={12} className='d-flex justify-content-center align-items-center'>
                            <StyledTitle>
                                {props.title}
                            </StyledTitle>
                        </Col>
                    )
                }

                <Col xs={{
                    span: 10,
                    offset: 1
                }}>
                    <Row className='mx-0'>
                        {
                            props.customers
                            .sort((a,b) => a.title.localeCompare(b.title))
                            .map((customer, index) => {
                                return (
                                    <Col
                                        key={customer.ID}
                                        lg={2}
                                        md={4}
                                        sm={6}
                                        xs={12}
                                        className='d-flex justify-content-center align-items-center my-3 my-lg-0 p-3'
                                    >
                                        <StyledLogo
                                            src={customer.image.url}
                                            height={customer.image.height }
                                            width={customer.image.width}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Col>
            </StyledRow>
        </Container>
    )
}

export default Customers